var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"user__short-name icon--small"},[_vm._v(_vm._s(_vm.shortName))])
}
var staticRenderFns = []

export { render, staticRenderFns }